(() => {
  function initializeCountdowns() {
    document.querySelectorAll('[data-sknd-countdown]').forEach((timer) => {
      if (timer.dataset.initialized) return;
      const target = Date.parse(timer.dataset.launchAt);
      if (!Number.isFinite(target)) return;
      timer.dataset.initialized = 'true';
      let interval;
      const tick = () => {
        const remaining = Math.max(0, Math.floor((target - Date.now()) / 1000));
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        Object.entries(values).forEach(([key, value]) => { const node = timer.querySelector(`[data-time="${key}"]`); if (node) node.textContent = String(value).padStart(2, '0'); });
        if (!remaining) {
          timer.closest('section, main')?.querySelectorAll('[data-countdown-complete]').forEach((node) => { node.hidden = false; });
          if (interval) window.clearInterval(interval);
        }
      };
      tick();
      if (target > Date.now()) interval = window.setInterval(tick, 1000);
    });
  }
  initializeCountdowns();
  document.addEventListener('shopify:section:load', initializeCountdowns);
})();
